import { useEffect, useState } from 'react';
import { API, PAGES, trackView } from '@vfit/shared/data-access';
import {
  CONSUMER_CMS_SHOPPING_CART,
  useCmsConfig,
  ITermsAndCondition,
  usePrivacyProfile,
} from '@vfit/consumer/data-access';
import { ICommonData, IPartyPrivacyItem } from '@vfit/shared/models';
import { useConsentsFlow } from '@vfit/consumer/hooks';
import { Consents, Skeleton } from '@vfit/shared/components';
import {
  organizePrivacyItems,
  organizeTermsAndConditionConsentCard,
} from './consentsList.utils';
import { useCheckout } from '../../../../../iBuyFixed.context';
import { ID_FLOWS } from '../../../../checkout.constants';
import { skeletonShape } from './consentsList.style';

const ConsentsList = ({ handleOnChangeEnableGoNext, handleGoNextSlide }: ICommonData) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { consents, setConsents, setCurrentStepKey } = useCheckout();
  const { partyPrivacyItems } = useConsentsFlow();
  const privacyProfile = usePrivacyProfile();

  const consentsCms = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_TERMS_AND_CONDITIONS
  ) as ITermsAndCondition;
  const { title, terms, description, actionText, modal } =
    organizeTermsAndConditionConsentCard(consentsCms);

  const onUpdateConsents = (updatedConsents: IPartyPrivacyItem[], goNext: boolean) => {
    setConsents({ partyPrivacyItems: updatedConsents });
    privacyProfile.mutate(updatedConsents);
    if (handleGoNextSlide && goNext) handleGoNextSlide();
  };

  useEffect(() => {
    if (consents.partyPrivacyItems.length === 0) {
      setConsents({ partyPrivacyItems });
    }
  }, [consents, partyPrivacyItems]);

  useEffect(() => {
    setCurrentStepKey(ID_FLOWS.CONSENTS);
    if (handleOnChangeEnableGoNext) {
      handleOnChangeEnableGoNext(true);
    }
  }, []);

  useEffect(() => {
    if (partyPrivacyItems.length > 0) {
      setIsLoading(false);
    }
  }, [partyPrivacyItems]);

  return (
    <>
      {isLoading && <Skeleton {...skeletonShape} />}
      {!isLoading && (
        <Consents
          title={title}
          description={description}
          terms={terms}
          partyPrivacyItems={organizePrivacyItems(consents.partyPrivacyItems, modal.list)}
          actionText={actionText}
          onUpdateConsents={onUpdateConsents}
          modal={modal}
          trackView={trackView}
        />
      )}
    </>
  );
};

export default ConsentsList;
